module.exports = __webpack_public_path__ + "files/5ae45986669d4d78720adfb8a277739e.png";